<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>電表列表
        <div class="card-header-actions">
          <b-link v-if="!cannotEdit && false" @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
        </div>
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
        <div slot="child_row" slot-scope="props">
          <b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
          <b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
        </div>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal title="刪除電表" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
        {{delRowMsg}}
    </b-modal>

    <b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" :no-enforce-focus="true" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
        <b-form>
            <h1>電表資料</h1>
            <p class="text-muted">綠框為必填</p>
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clone"></i>專案名稱</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="請輸入專案名稱" 
                            v-model.lazy.trim="$v.record.project_name.$model"
                            v-focus
                            :state="chkState('project_name')"
                            aria-describedby="invalidProjectNameFeedback"/>
              <b-form-invalid-feedback id="invalidProjectNameFeedback">專案名稱必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="cui-globe"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-select id="device-company-id"
                            class="form-control hidden" 
                            placeholder="*Company" 
                            v-model.lazy.trim="$v.record.company_id.$model"
                            v-focus
                            :state="chkState('company_id')"
                            aria-describedby="invalidCNFeedback"/>
              <b-form-invalid-feedback id="invalidCNFeedback">必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clone"></i>電表ID</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="number" 
                            class="form-control" 
                            placeholder="請輸入ID"
                            v-model.lazy.trim="$v.record.meterid.$model"
                            v-focus
                            :state="chkState('meterid')"
                            aria-describedby="invalidMeterIdFeedback"
                            min="1"/>
              <b-form-invalid-feedback id="invalidMeterIdFeedback">電表ID必填</b-form-invalid-feedback>
            </b-input-group>
        </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import config from '@/config/global'
import {ServerTable, Event} from 'vue-tables-2'
import io from 'socket.io-client'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import jQuery from 'jquery'
import vSelect from 'vue-select'
import notifications from '@/config/notifications'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
  peoject_name: '',
  meterid: 1,
  company_id: '',
};

let $company_id_select2 = null;

Vue.use(ServerTable)

export default {
  name: 'admin_list',
  notifications,
  components: {
    ServerTable,
    Event,
    vSelect,
  },
  data() {
    let app = this;
    let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

    return {
      cannotEdit,
      selected_row: null,
      editRowId: null,
      record: Object.assign({}, clean_form),
      showEditorModal: false,
      delRowShowModal: false,
      delRowId: 0,
      delRowMsg: '',
      columns: ['id', 'company_id', 'project_name', 'meterid', 'created'],
      data: [],
      options: {
        debounce: 86400000, // 停止預設的即時搜尋
        headings: {
          company_id: '公司',
          project_name: '專案名稱',
          meterid:    '電表ID'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['company_id', 'project_name', 'created'],
        filterable: ['company_id', 'project_name'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          let action = `${admin_root}/get_list/Meter`;
          let params = {
            keyset: 'mqtt',
            token: app.$state.$get('adminuser').token
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = data[col];
          }

          return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
        }//eo requestFunction
      },
    };
  },
  mounted(){
    let app = this;
    // Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});
  },
  beforeDestroy(){

  },
  methods: {
    chkState(val) {
      const field = this.$v.record[val];
      return !field.$dirty || !field.$invalid;
    },
    editRow(row_id, row) {
      // console.info('edit row_id:', row_id);
      this.selected_row = row;
      this.openEditor(row_id);

      this.record = Object.assign({}, this.selected_row);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
    },//eo delRow

    submitDelRow(row_id) {
      let app    = this;
      let action = `${admin_root}/update_meter`;
      let params = {
        keyset: 'mqtt',
        record: encodeURIComponent(encrypt(JSON.stringify({
          id: row_id,
          field: 'valid',
          value: 0,
          value_type: 'int'
        })))
      };

      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '資料更新成功',
            message: result.message
          });

          app.$refs['dataTable'].refresh();
        } else {
          app.showError({
            title: '資料更新失敗',
            message: result.message
          });
        }
      }).catch(error => {
        app.showError({
          title: '資料更新失敗',
          message: error
        });
      });
    },

    openEditor(row_id){
      this.editRowId       = row_id;
      this.showEditorModal = true;
      this.$v.$reset();

      let page_limit = 10;
      let app        = this;

      //workaround for select2 to be able to use search input
      jQuery('div.modal-content').removeAttr('tabindex');

      $company_id_select2 = jQuery('#device-company-id');

      let ccff = this.$state.$get('ccff');
      if(ccff && ccff !== 'N/A'){
        ccff = config.decrypt(ccff, config.ffkey, config.ffiv);
        $company_id_select2.parents('div.input-group').hide();
        app.record.company_id = ccff;
        app.ccff              = ccff;
      }

      if($company_id_select2.length){
        //init select2
        $company_id_select2.select2({
          width: 'copy',
          dropdownAutoWidth: true,
          placeholder: '所屬公司...',
          allowClear: true,
          ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
            url: `${admin_root}/get_option_list/Company`,
            type: 'POST',
            dataType: 'json',
            quietMillis: 800 ,
            beforeSend: function (xhr) {
              xhr.setRequestHeader(
                "Authorization",
                "Bearer " + app.$state.$get('adminuser').token
              );
            },
            data: function (params) {
              let preselected_id = jQuery(this).val();
              return {
                preselected_id: preselected_id,
                query:          params.term, // search term
                page_limit:     page_limit,
                page:           params.page || 1
              };
            },
            results: function (data, page) {
              var more = (page * page_limit) < data.total;
              return {results: data.results, more: more};
            }
          },//eo ajax
        }).on('change', (event) => {
          app.record.company_id = $company_id_select2.select2('val');
        });
      }//eo $company_id_select2 init

      //workaround for Bootstrap4
      if($company_id_select2.data('select2')){
        $company_id_select2.data('select2').$container.addClass("form-control");
      }

      if(row_id && app.selected_row){
        let $option1 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.company_id);
        $company_id_select2.val(app.selected_row.company_id).trigger('change');
        
        let action = `${admin_root}/get_option_list/Company`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
          },
          body: JSON.stringify({
            id: app.selected_row.company_id
          })
        }).then(res => res.json()).then(result => {
          if(result.results.length){
            let rec = result.results.pop();
            $option1.text(rec.text).val(rec.id);
            $option1.removeData();

            $company_id_select2.html('');

            $company_id_select2.append($option1);

            $company_id_select2.trigger({
                type: 'select2:select',
                params: {
                  data: rec
                }
            });

            $company_id_select2.val(rec.id).trigger('change');
          } else {
            // $option.revmove();
            $company_id_select2.val(null);
            app.showError({
              message: '無法讀取公司資料，請重新指定'
            });
          }
        }).catch(error => {
          // $option.revmove();
          $company_id_select2.val(null);
          app.showError({
            message: '無法讀取公司資料，請重新指定'
          });
        });
      }

      if(!row_id){
        app.record       = Object.assign({}, clean_form);
        app.selected_row = null;
        app.row_id       = null;
      }
    },

    submitRecord() {
      let app    = this;
      let row_id = app.editRowId;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
        this.showEditorModal = true;
        return false;
      }

      let to_save = this.record;

      if(row_id){
        to_save['id'] = row_id;
      }
      let selected_company = $company_id_select2.select2('data').pop();

      // console.info('selected_company:', selected_company);return;

      if(selected_company){
        to_save['company'] = selected_company.text;
      }

      if(app.ccff){
        to_save['company_id'] = app.ccff;
        to_save['company']    = this.$state.$get('company_name');
      }

      //console.info('before send: ', to_save);
      to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));
      let action = `${admin_root}/save_meter`;
      let params = {
        keyset: 'mqtt',
        record: to_save
      };

      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '成功',
            message: '資料成功儲存'
          });
          app.$refs['dataTable'].refresh();
          app.record = Object.assign({}, clean_form);
          app.$v.$reset();
        } else {
          let cat_msg = '';

          if(result.error && result.error.errors && result.error.errors.length){
            result.error.errors.forEach((err) => {
              cat_msg += "\n" + `[${err.type}]:` +err.message + "\n";
            });
          }

          app.showError({
            title: '錯誤',
            message: '無法儲存資料，請稍後再試。'+cat_msg,
            timeout: 10000
          });
          app.$refs['dataTable'].refresh();
        }
      }).catch(error => {
        app.showError({
          title: '錯誤',
          message: '無法儲存資料，請稍後再試。',
          timeout: 10000
        });
        app.$refs['dataTable'].refresh();
      });
    },
  },
  validations: {
    record: {
      project_name: {
        required,
        minLength: minLength(1)
      },
      company_id: {
			  required
			},
      meterid: {
        required,
        integer
      },
      company_id: {
        required,
      },
    }
	},//eo validations
};
</script>
  
<style>
/* 整個頁面黑色背景 */
.container2 {
  text-align: center;
  padding: 20px;
  background-color: #000; /* 黑色背景 */
  color: white; /* 文字變白 */
  height: 80vh;
  /*min-height: 70vh;  讓頁面填滿整個畫面 */
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;  /* 讓 `.container` 佔滿父層 */
  max-width: 100vw;
  height: 80vh;
  background-color: black;
  color: white; /* 文字變白 */
  position: relative;
}

/* 標題樣式 */
.title {
  font-size: 28px; /* 放大標題 */
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

.subtitle {
  font-size: 18px; /* 放大副標題 */
  color: gray;
  margin-bottom: 20px;
}

/* 表格樣式 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #222; /* 深灰色表格背景 */
  font-size: 22px; /* 整體字體變大 */
  border: 2px solid red;
}

.data-table th, .data-table td {
  border: 2px solid #555; /* 灰色邊框 */
  padding: 15px; /* 增加間距 */
  text-align: center;
  color: white; /* 白色文字 */
}

.data-table th {
  background-color: #444; /* 深灰色標題 */
  color: #00ff00; /* 綠色標題字體 */
  font-size: 24px; /* 表頭字體再大一點 */
}
</style>
  